import { Flex, FlexProps, Heading } from '@chakra-ui/react';
import React from 'react';

type PlacesPageMainHeaderProps = FlexProps & React.RefAttributes<HTMLDivElement>

export const PlacesPageMainHeader: React.FC<PlacesPageMainHeaderProps> = ({
    ...props
}) => (
    <Flex
        flexDirection="row"
        {...props}
    >
        <Heading
            flex={1}
            textDecoration="underline"
        >
            ПАРТНЁРСКИЕ ПЛОЩАДКИ
        </Heading>
    </Flex>
);
